export * from './file-gallery/file-gallery.component';
